import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import stitches from "../theme.config.es.js";
import { domProps } from "../../utils/domProps.es.js";
const layout = stitches.css({
  "&& > * + *": {
    marginTop: "$form-gap"
  }
});
const EzFormLayout = forwardRef((initProps, ref) => {
  const props = domProps(initProps, layout());
  return /* @__PURE__ */ jsx("div", { ...props, ref });
});
EzFormLayout.displayName = "EzFormLayout";
export {
  EzFormLayout as default
};
//# sourceMappingURL=EzFormLayout.es.js.map
